import { render, staticRenderFns } from "./sendModal.vue?vue&type=template&id=c8f1a006&"
import script from "./sendModal.vue?vue&type=script&lang=js&"
export * from "./sendModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports